// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33OFx","content":"styles_content__3iA3y","tableWrap":"styles_tableWrap__2wluj"};